import React from 'react';

const TPE_PATHS = (
    <>
        <path d="M18.4998 32.2641H83.4966V224C83.4966 240.5 111.497 240.5 111.497 224V32.2641H177.499C194.501 32.2641 194.501 5 177.499 5L18.5007 4.5C1.00011 4.5 0.498883 32.2641 18.4998 32.2641Z" />
        <path d="M217.872 32.3406H327.496C371.996 32.3406 372.496 107 327.496 107H213C207 107 203.996 110 203.996 116V224.161C203.996 240.563 232.124 240.563 232.124 224.161V136C232.124 134 233.054 133.235 234.851 133.235H323.496C411.496 133.235 411.496 4.99854 323.496 4.99854H217.873C200.293 4.99854 199.789 32.3406 217.872 32.3406Z" />
        <path d="M419.314 5C401.814 5 401.312 32.7641 419.313 32.7641H578.312C595.315 32.7641 595.315 5.5 578.313 5.5L419.314 5Z" />
        <path d="M419.314 107C401.814 107 401.312 134.764 419.313 134.764H578.312C595.315 134.764 595.315 107.5 578.313 107.5L419.314 107Z" />
        <path d="M419.314 209C401.814 209 401.312 236.764 419.313 236.764H578.312C595.315 236.764 595.315 209.5 578.313 209.5L419.314 209Z" />
    </>
);

export const LogoTPE = ({ classname, height, width, isLightLogo }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 596 242"
        width={width}
        height={height || 32}
        className={classname}
        fill={isLightLogo ? '#111111' : '#FFFFFF'}
        role="img"
        aria-label="TPE"
    >
        {TPE_PATHS}
    </svg>
);
